import { createReducer } from '@ngrx/store';
import { PageVersion } from '../domain/page-version';
import * as Actions from './page-edit-screen.actions';

export const featureKey = 'cxbPageEditScreen';

export interface FeatureState {
  page: PageVersion;
  loading: boolean;
  countryCodes: string[];
  userSegments: string[];
}

export interface AppState {
  [featureKey]: FeatureState;
}

export const initialState: FeatureState = {
  page: undefined,
  loading: false,
  countryCodes: undefined,
  userSegments: undefined,
};

export const reducer = createReducer(
  initialState,
  ...Actions.loadCxbPageEditScreen.reduce<FeatureState>(
    (state, action): FeatureState => ({ ...state, loading: false, page: action.page }),
    (state, action): FeatureState => ({
      ...state,
      loading: true,
      page: undefined,
      countryCodes: action.countryCodes,
      userSegments: action.userSegments,
    })
  ),

  ...Actions.publishCxbPageDraft.reduce<FeatureState>(),
  ...Actions.deleteCxbPageDraft.reduce<FeatureState>(),
  ...Actions.unpublishCxbPage.reduce<FeatureState>(),
  ...Actions.deleteCxbPageItem.reduce<FeatureState>(),
  ...Actions.cloneCxbPageItem.reduce<FeatureState>(),
  ...Actions.createCxbPageDraft.reduce<FeatureState>(),
  ...Actions.updateCxbPageVersion.reduce<FeatureState>(),
  ...Actions.updateCxbRedeemPageVersion.reduce<FeatureState>(),
  ...Actions.updateCxbPageItems.reduce<FeatureState>((state, action) => ({ ...state, page: action.page }))
);
